<template>
<div :id="wrapperId" :class="cssClass" class="position-relative d-flex">
    <f-set v-if="canSelectType" cssClass="w-125-px pr-2" :value="value.type" @input="updateValue($event,'type')" :data="c_fields.type"/>
    <f-set cssClass="flex-grow-1 pr-2 pt-25" :value="value.email" @input="updateValue($event,'email')" :data="c_fields.email"/>
</div>
    
</template>

<script>
import Vue from 'vue'
import fieldBuilder from '@/mixins/fieldBuilder'

export default {
    mixins: [fieldBuilder],
    props: ['value','label','fields','emailType','cssClass'],
    data() {
        return {
            wrapperId: 'email-' + new Date().getTime(),
            d_fields: {
                type: this.makeField({ name: 'type', label: this.label ? this.label : 'Email', type: 'select', options: { 'personal': 'Personal', 'work': 'Work' } }),
                email: this.makeField({ name: 'email', label: false }),
            },
            d_values: {
                hash: this.value.hash,
                type: this.value.type,
                email: this.value.email
            }
        }
    },
    computed: {
        canSelectType() {
            return typeof(this.emailType) == 'undefined' || this.emailType.length == 0;
        },
        c_fields() {
            return typeof(this.fields) !== 'undefined' ? this.fields : this.d_fields;
        }
    },
    methods: {
        updateValue(val, field) {
            if (field == 'email' && val && !this.d_values.email && this.canSelectType && !this.d_values.type) {
                //setting up default type on typing a blank email
                this.d_values.type = 'personal';
            }
            this.d_values[field] = val;
            this.$emit('input', this.d_values)
        }
    },
    mounted() {
        this.$emit('input', this.d_values) // this line is so not empty string is returned, but at least an object
    }
}
</script>